<template>
  <div>
      <el-table :data="data" style="width: 100%">
        <el-table-column prop="company_name" label="公司名称"></el-table-column>
        <el-table-column prop="show_name" label="对外显示名称"></el-table-column>
        <el-table-column prop="scale" label="公司规模" :formatter="setScale"></el-table-column>
        <el-table-column prop="capitalization" label="融资阶段" :formatter="setcapitalization"></el-table-column>
        <el-table-column fixed="right" label="操作" width="80">
        <template slot-scope="scope">
            <el-button @click="handleEditCompany(scope.row)" type="text" size="small">编辑</el-button>
        </template>
        </el-table-column>
    </el-table>
    <div class="comtable-compage" :page="page">
        <p>共 {{page.total}} 条记录 第 {{page.current_page}} / {{page.last_page}} 页</p>
        <el-pagination layout="prev, pager, next" :current-page="page.current_page" :page-size="page.per_page" :total="page.total" prev-text="<上一页" next-text="下一页>" @current-change="tablePageChange"></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
    data(){
        return{
            
        }
    },
    props:{
        data:{
            type:Array
        },
        page: {
            type: Object
        }
    },
    methods:{
        // 处理表格动态数据
        setScale(row, column) {
            if (row.scale === 0) {
                return "不限";
            } else if (row.scale === 1) {
                return "1-49人";
            } else if (row.scale === 2) {
                return "20-99人";
            } else if (row.scale === 3) {
                return "100~499人";
            } else if (row.scale === 4) {
                return "500-999人";
            } else {
                return "1000人以上";
            }
        },
        // 融资阶段动态处理
        setcapitalization(row, column) {
            if (row.capitalization === "") {
                return "-";
            } else {
                return row.capitalization;
            }
        },
        tablePageChange(events) {
            this.$emit('pageChange', events);
        },

        handleEditCompany(id){
            this.$emit('handleEditCompany', id);
        },
    }
}
</script>
<style scoped>
    /* page */
    .comtable-compage {
        width: 100%;
        padding: 40px 0 80px 0;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        box-sizing: border-box;
    }

    .comtable-compage p {
        display: inline-block;
        height: 46px;
        line-height: 46px;
        font-size: 12px;
        color: #888;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
</style>
<style>
    /* 分页样式 */
    .comtable-compage .el-pagination button, .el-pagination span:not([class*=suffix]){
        height: 36px !important;
        line-height: 36px !important;
        padding: 0 7px !important;
    }
    .el-pager li.active+li{
        border: 1px solid #EAEAEA !important;
    }
    .el-pager li {
        padding: 0 14px !important;
        height: 36px !important;
        line-height: 36px !important;
        margin: 0 10px !important;
    }
    .el-pagination .btn-next,.el-pagination .btn-prev,.el-pagination .el-pager li {
        background-color: #fff !important;
        border-radius: 2px !important;
        border: 1px solid #EAEAEA !important;
        color: #555 !important;
    }
    .el-pagination .el-pager li:not(.disabled).active{
        background-color: #fff !important;
        border-radius: 2px !important;
        border: 1px solid #0077FF !important;
        color: #0077FF !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/TablePageCompanyList.vue